import { render } from "./CustomKeeperForm.vue?vue&type=template&id=0dda38a9"
import script from "./CustomKeeperForm.vue?vue&type=script&lang=js"
export * from "./CustomKeeperForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__